import React from "react";
import Paper from "@material-ui/core/Paper";
import styles from "./styles";
import { GridVideo } from "./GridVideo";
import { VideoSlider } from "../../../components/VideoSlider";
import { Hidden } from "@material-ui/core";

export const VideoSection = () => {
  const classes = styles();
  return (
    <section id="video" className={classes.videoSectionContainer}>
      <div className={classes.videoSection}>
        <div className={classes.relativeMobile}>
          <h1 className={classes.bannerTitle}>
            <div className={classes.bannerRectangle}></div>
            Videos Destacados
          </h1>
          <p>
            Para mayor facilidad de nuestros usuarios hemos seleccionado los
            videos más visitados para que sea de mejor comprensión, a
            continuación haz clic en el video de tu interés.
          </p>
        </div>
      </div>
      <Hidden xsDown>
        <GridVideo />
      </Hidden>
      <Hidden smUp>
        <VideoSlider />
      </Hidden>
    </section>
  );
};
